import { EdgeLogItemTodoRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LogItemTodo } from '@/shared/domain/use-cases'

export function makeLogItemTodo(): LogItemTodo {
  return new EdgeLogItemTodoRepository(makeSupabaseEdgeHttpClient()).execute
}
